module.exports = __webpack_public_path__ + "static/3_3_spam-or-ham_NB-d5f2d623f20c5a0ea0d8c637374d3028.svg";